import { createAsyncActionType } from './index';

export const DOCUMENTS_LIST_GET = createAsyncActionType(
  'documents',
  'DOCUMENTS_LIST_GET'
);

export const DOCUMENT_DETAILS_GET = createAsyncActionType(
  'documents',
  'DOCUMENT_DETAILS_GET'
);

export const DOCUMENTS_CATEGORIES_GET = createAsyncActionType(
  'documents',
  'DOCUMENTS_CATEGORIES_GET'
);

export const DOCUMENT_DETAILS_RESET = '@@documentss/DOCUMENT_DETAILS_RESET';

export const DOCUMENT_DELETE = createAsyncActionType(
  'documents',
  'DOCUMENT_DELETE'
);
